import clsx from 'clsx';
import { useLocation } from 'react-router-dom';

const CartContainer = ({
  children,
  isOpen,
  onClick,
}: {
  children: React.ReactNode;
  isOpen: boolean;
  onClick: () => void;
}) => {
  const location = useLocation();
  const isCheckoutPage = location.pathname.includes('/checkout');
  return (
    <div
      className={clsx(
        'flex-none overflow-hidden bg-blue-900 shadow-[-15px_4px_24px_0px_rgba(0,0,0,0.25)] transition-all duration-700',
        'fixed right-0 top-16 z-[49] xl:sticky xl:top-0',
        'h-[calc(100vh-64px)] max-h-[calc(100vh-64px)] xl:h-full xl:max-h-screen',
        isOpen ? 'w-full xs:w-[400px]' : 'w-[64px]',
      )}
    >
      <div
        className={clsx(
          'flex h-full flex-col  overflow-hidden px-6 py-8 transition-all duration-700',
          isOpen ? 'w-full xs:w-[400px]' : 'w-[64px]',
          { 'gap-[56px]': isCheckoutPage, 'gap-[92px]': !isCheckoutPage },
        )}
      >
        {children}
      </div>
      <div
        onClick={onClick}
        className={clsx(
          'absolute bottom-0 left-0 top-0 w-[64px]',
          isOpen ? 'pointer-events-none' : 'cursor-pointer',
        )}
      ></div>
    </div>
  );
};

export default CartContainer;
